import "core-js/modules/es.array.map";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
export var SwitcherModal = function SwitcherModal(_ref) {
  var header = _ref.header,
      onClickOption = _ref.onClickOption,
      options = _ref.options;
  return React.createElement("div", {
    className: "SwitcherModal"
  }, header && React.createElement("header", {
    className: "SwitcherModal__header"
  }, header), options.map(function (_ref2) {
    var display = _ref2.display,
        value = _ref2.value,
        selected = _ref2.selected;
    return React.createElement("div", {
      onClick: function onClick() {
        return onClickOption(value);
      },
      key: value,
      className: classNames('SwitcherModal__item', {
        'is-active': selected
      })
    }, display);
  }));
};
SwitcherModal.propTypes = {
  header: PropTypes.element,
  onClickOption: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    display: PropTypes.string,
    selected: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }))
};